import { render } from "./AboutMissionVisionComp.vue?vue&type=template&id=2414c532&scoped=true"
import script from "./AboutMissionVisionComp.vue?vue&type=script&lang=js"
export * from "./AboutMissionVisionComp.vue?vue&type=script&lang=js"

import "./AboutMissionVisionComp.vue?vue&type=style&index=0&id=2414c532&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2414c532"]])

export default __exports__